module.exports = __webpack_public_path__ + "static/img/dn3.72d06dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dn3.png
// module id = tByp
// module chunks = 0